import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { environment } from '@environments/environment';

/**
 * Persists the organ recovery confirmation answer (TAC2-2006).
 *
 * Deliberately the only HTTP surface for the answer: both the SR-level Job Done flow and the
 * leg-level Job Done flows save through this one PATCH before their transition is retried.
 */
@Injectable({
  providedIn: 'root',
})
export class OrganRecoveryConfirmationHttpService {
  constructor(private httpClient: HttpClient) {}

  /**
   * Saves the answer for one service request. Idempotent while the service request is not Completed.
   */
  saveAnswer(serviceRequestId: string, organRecoveredAndTransported: boolean): Observable<void> {
    const url = `${environment.apiHostV2}/service-requests/${serviceRequestId}/organ-recovery-confirmation`;

    return this.httpClient
      .patch<void>(url, { organRecoveredAndTransported })
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }
}
